if (slideAutoScroll) {
slideDuration = 4000;
} else {
slideDuration = 0;
}

jQuery(window).bind("load", function() {
	jQuery('#featured-panels').cycle({
	    cleartypeNoBg: true,
	    fx:     'scrollHorz', 
easing: 'easeOutQuart',
pause:  1,
	    speed:  1000, 
	    timeout: slideDuration, 
	    next:   '#next2', 
	    prev:   '#prev2' 
	});
});

jQuery(document).ready(function(){

jQuery("a[rel='lightbox']").colorbox({transition:"elastic"});

jQuery('.go-back a').click(function() {
javascript:history.back();
return false;
});

style = 'easeOutQuart';
jQuery('#product-collection li').hover(  
function() {  
//show
jQuery(this).children('div:first').stop(false,true).animate({bottom:1},{duration:500, easing: style});  
},  
   
function() {  
//hide
jQuery(this).children('div:first').stop(false,true).animate({bottom:-70},{duration:500, easing: style});  
}  
);

jQuery('#search-input').click(function() {
jQuery(this).val('');
});

	jQuery('#sidebar-accordion').accordion({
	header: 'h3',
	selectedClass: 'selected',
	navigation: true,
	autoHeight: false,
	active: '.selected',
animated: 'bounceslide',
	alwaysOpen: false
	});


	jQuery("#sidebar-accordion ul.animated a").hover(function(){
		jQuery(this).stop().animate({ paddingLeft: "20px" }, 'fast');
	}, function(){
		jQuery(this).stop().animate({ paddingLeft: "10px" }, 'fast');
	});



});